import { z } from 'zod';

export const discountCodeSchema = z.object({
  code: z.string(),
  discountPercent: z.number(),
  isActive: z.boolean().default(true),
  /** Max redemptions per customer (identified by phone number). `null` means unlimited. */
  usageLimitPerCustomer: z.number().nullable().default(null),
  restaurantId: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type DiscountCode = z.output<typeof discountCodeSchema>;

export const discountCodeStrictSchema = discountCodeSchema.safeExtend({
  code: z
    .string()
    .trim()
    .min(1, 'Code is required')
    .max(20, 'Code must be 20 characters or less')
    .regex(/^\S+$/, 'Code must not contain spaces')
    .toUpperCase(),
  discountPercent: z.number().int().min(5, 'Minimum 5%').max(100, 'Maximum 100%'),
  usageLimitPerCustomer: z.number().int().min(1).nullable(),
  updatedAt: z.number().default(() => Date.now()),
});

export const discountCodeCvxSchema = discountCodeSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type DiscountCodeCvx = z.output<typeof discountCodeCvxSchema>;

//
// Forms
//

export const discountCodeForms = {
  createEdit: z.object(discountCodeStrictSchema.shape).pick({
    code: true,
    discountPercent: true,
    isActive: true,
    usageLimitPerCustomer: true,
  }),
};
